// Fabric data
const fabrics = [
  {
    name: 'Circus Circus',
    sku: 'CKCIR',
  },
  {
    name: 'Dainty Rose',
    sku: 'CKDNT',
  },
  {
    name: 'Starry Moons',
    sku: 'CKSTM',
  },
  {
    name: 'Winking Diamonds',
    sku: 'CKWNK',
  },
  // Hues Fabrics
  {
    name: 'Hues Collection Fabric',
    sku: 'HU100',
  },
  {
    name: 'Quartz Hues',
    sku: 'QZHUE',
  },
  {
    name: 'Driftwood Hues',
    sku: 'DRHUE',
  },
  {
    name: 'Flax Hues',
    sku: 'FLHUE',
  },
  {
    name: 'Granite Hues',
    sku: 'GRHUE',
  },
  {
    name: 'Umber Hues',
    sku: 'UMHUE',
  },
  {
    name: 'Juniper Hues',
    sku: 'JUHUE',
  },
  {
    name: 'Cognac Hues',
    sku: 'CGHUE',
  },
  // Heather Taylor Home
  {
    name: 'Mini Gingham Cream',
    sku: 'HTHCM',
  },
  {
    name: 'Gingham Sage',
    sku: 'HTHSG',
  },
  {
    name: 'Soho Nutmeg',
    sku: 'HTHNT',
  },
  // Essentials
  {
    name: 'Cloud 100% Linen',
    sku: 'CL100',
  },
  {
    name: 'Magnolia 100% Linen',
    sku: 'MA100',
  },
  {
    name: 'Limestone 100% Linen',
    sku: 'LI100',
  },
  {
    name: 'Jute 100% Linen',
    sku: 'JU100',
  },
  {
    name: 'Fog 100% Linen',
    sku: 'FO100',
  },
  {
    name: 'Agave 100% Linen',
    sku: 'AG100',
  },
  {
    name: 'Indigo 100% Linen',
    sku: 'IN100',
  },
  {
    name: 'Flint 100% Linen',
    sku: 'FL100',
  },
  {
    name: 'Shale 100% Linen',
    sku: 'SH100',
  },
  {
    name:'Carbon 100% Linen',
    sku: 'CA100',
  },
  {
    name: 'Cloud Linen Blend',
    sku: 'CLLIB',
  },
  {
    name: 'Magnolia Linen Blend',
    sku: 'MALIB',
  },
  {
    name: 'Limestone Linen Blend',
    sku: 'LILIB',
  },
  {
    name: 'Jute Linen Blend',
    sku: 'JULIB',
  },
  {
    name: 'Fog Linen Blend',
    sku: 'FOLIB',
  },
  {
    name: 'Agave Linen Blend',
    sku: 'AGLIB',
  },
  {
    name: 'Indigo Linen Blend',
    sku: 'INLIB',
  },
  {
    name: 'Flint Linen Blend',
    sku: 'FLLIB',
  },
  {
    name: 'Shale Linen Blend',
    sku: 'SHLIB',
  },
  {
    name: 'Carbon Linen Blend',
    sku: 'CALIB',
  },
  {
    name: 'Stone Textured Linen Blend',
    sku: 'STTLB',
  },
  {
    name: 'Wheat Textured Linen Blend',
    sku: 'WHTLB',
  },
  {
    name: 'Powder Textured Linen Blend',
    sku: 'POTLB',
  },
  {
    name: 'Natural Textured Linen Blend',
    sku: 'NATLB',
  },
  {
    name: 'Dove Textured Linen Blend',
    sku: 'DOTLB',
  },
  {
    name: 'Cloud 100% Linen Sheers',
    sku: 'CLLSH',
  },
  {
    name: 'Magnolia 100% Linen Sheers',
    sku: 'MALSH',
  },
  {
    name: 'COM',
    sku: 'COMAT',
  },
  {
    name: 'COM Sheers',
    sku: 'COMSH',
  },
  {
    name: 'COM + COM TRIM',
    sku: 'COMTR',
  },
  {
    name: 'Petal Linen Blend',
    sku: 'PELIB',
  },
  {
    name: 'Mint Linen Blend',
    sku: 'MILIB',
  },
  {
    name: 'Sky Linen Blend',
    sku: 'SKLIB',
  },
  {
    name: 'Denim Linen Blend',
    sku: 'DELIB',
  },
  {
    name: 'Petal Cotton Stripe',
    sku: 'PESTR',
  },
  {
    name: 'Mint Cotton Stripe',
    sku: 'MISTR',
  },
  {
    name: 'Sky Cotton Stripe',
    sku: 'SKSTR',
  },
  {
    name: 'Denim Cotton Stripe',
    sku: 'DESTR',
  },
  {
    name: 'Ivory Cotton Stripe',
    sku: 'IVSTR',
  },
  {
    name: 'Oyster Cotton Stripe',
    sku: 'OYSTR',
  },
  {
    name: 'Cloud Linen Blend + Petal Trim',
    sku: 'PETRM',
  },
  {
    name: 'Cloud Linen Blend + Mint Trim',
    sku: 'MITRM',
  },
  {
    name: 'Cloud Linen Blend + Sky Trim',
    sku: 'SKTRM',
  },
  {
    name: 'Cloud Linen Blend + Denim Trim',
    sku: 'DETRM',
  },
  {
    name: 'No Fabric',
    sku: '00000',
  },
  {
    name: 'Moon Essentials',
    sku: 'MOESS',
  },
  {
    name: 'Bone Essentials',
    sku: 'BOESS',
  },
  {
    name: 'Pebble Essentials',
    sku: 'PBESS',
  },
  {
    name: 'Sand Essentials',
    sku: 'SDESS',
  },
  {
    name: 'Birch Essentials',
    sku: 'BCESS',
  },
  {
    name: 'Fawn Essentials',
    sku: 'FWESS',
  },
  {
    name: 'Ash Essentials',
    sku: 'ASESS',
  },
  {
    name: 'Storm Essentials',
    sku: 'SMESS',
  },
  {
    name: 'Sage Essentials',
    sku: 'SGESS',
  },
  {
    name: 'Rose Essentials',
    sku: 'RSESS',
  },
  {
    name: 'Moon + Petal Trim',
    sku: 'MOPET',
  },
  {
    name: 'Moon + Denim Trim',
    sku: 'MODET',
  },
  {
    name: 'Moon + Ivory Trim',
    sku: 'MOIVT',
  },
  {
    name: 'Moon + Oyster Trim',
    sku: 'MOOYT',
  },
  {
    name: 'Moon + Midnight Trim',
    sku: 'MOMDT',
  },
  {
    name: 'Moon Sheers',
    sku: 'MOSHR',
  },
  {
    name: 'Bone Sheers',
    sku: 'BOSHR',
  },
  {
    name: 'Pebble Sheers',
    sku: 'PBSHR',
  },
  {
    name: 'Manchester | United White',
    sku: 'MANWT',
  },
  {
    name: 'Manchester | Beige Wales',
    sku: 'MANBG',
  },
  {
    name: 'Manchester | Burlap Chester',
    sku: 'MANBC',
  },
  {
    name: 'Manchester | Foggy Lake',
    sku: 'MANFG',
  },
  {
    name: 'Soft Linen | Sandy Beach',
    sku: 'SLSND',
  },
  {
    name: 'Mercury II | Snow',
    sku: 'MRCSN',
  },
  {
    name: 'Mercury II | Stone',
    sku: 'MRCST',
  },
  {
    name: 'Mercury II | Ash',
    sku: 'MRCAS',
  },
  {
    name: 'Mercury II | Silver',
    sku: 'MRCSL',
  },
  {
    name: 'Khaki Woven Wood',
    sku: 'KHWVW',
  },
  {
    name: 'Chestnut Woven Wood',
    sku: 'CHWVW',
  },
  {
    name: 'Cocoa Woven Wood',
    sku: 'COWVW',
  },
  {
    name: 'Seashell Woven Wood',
    sku: 'SEWVW',
  },
  {
    name: 'Onyx Woven Wood',
    sku: 'ONWVW',
  },
  {
    name: 'Dune Woven Wood',
    sku: 'DUWVW',
  },
  {
    name: 'Bluff Woven Wood',
    sku: 'BLWVW',
  },
  {
    name: 'Oak',
    sku: 'OAKMS',
  },
];

const hardware = [
  {
    name: 'Brass',
    sku: 'BRSS'
  },
  {
    name: 'Bronze',
    sku: 'ORBZ'
  },
  {
    name: 'Black',
    sku: 'MBLK'
  },
]
  
// Create a lookup map for efficiency
const fabricMap = fabrics.reduce((map, fabric) => {
    map[fabric.sku] = fabric.name;
    return map;
}, {});

// Create a lookup map for efficiency
const hardwareMap = hardware.reduce((map, hardwareItem) => {
  map[hardwareItem.sku] = hardwareItem.name;
  return map;
}, {});
  
export class Fabric {
  static getFabricNameBySKU(sku) {
    if (typeof sku !== 'string') return sku;
    return fabricMap[sku] || sku;
  }

  static getHardwareNameBySKU(sku) {
    if (typeof sku !== 'string') return sku;
    return hardwareMap[sku] || sku;
  }
}